import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ProjectResource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  disableProjectResource(
    request: Boundaries["disableProjectResource"]["request"],
  ): void;
}

function useDisableProjectResource(
  projectResource: Identifiable<ProjectResource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDisableProjectResourceRequestPending(projectResource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDisableProjectResourceRequestSuccess(projectResource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDisableProjectResourceRequestFailure(projectResource),
    ),
    disableProjectResource: core.disableProjectResource,
  };
}

export { useDisableProjectResource };
